import { reduce as polyfillReduce } from './reduce';
import { stringify as polyfillStringfy } from './stringify';
// fix conficts with prototype.js http://prototypejs.org/
export function reduce(arr, callbackFn, initialValue) {
    var isReduceNative = 
    /* @ts-ignore */
    "".concat(Array.prototype.reduce) === 'function reduce() { [native code] }';
    return isReduceNative
        ? arr.reduce(callbackFn, initialValue)
        : polyfillReduce(arr, callbackFn, initialValue);
}
export function stringify(data, replacer, space) {
    /* @ts-ignore */
    var isStringifyNative = Object.toJSON === undefined;
    return isStringifyNative
        ? JSON.stringify(data, replacer || undefined, space)
        : polyfillStringfy(data, replacer, space);
}
